export default {
    openBlockId: null,
    blockBounds: {},
    blockIds: [],
};
